// One short, soft two-tone chime when Live transcription stops because the
// connection was lost. Generated with Web Audio (no file to download while
// offline). Silently does nothing where audio output is unavailable.
export function playConnectionLostSound() {
  try {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextClass) return;
    const context = new AudioContextClass();
    const gain = context.createGain();
    gain.connect(context.destination);
    const start = context.currentTime;
    gain.gain.setValueAtTime(0.0001, start);
    gain.gain.exponentialRampToValueAtTime(0.18, start + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.6);
    [[880, 0], [660, 0.22]].forEach(([frequency, offset]) => {
      const tone = context.createOscillator();
      tone.type = 'sine';
      tone.frequency.setValueAtTime(frequency, start + offset);
      tone.connect(gain);
      tone.start(start + offset);
      tone.stop(start + offset + 0.3);
    });
    setTimeout(() => { void context.close?.().catch?.(() => {}); }, 1000);
  } catch (_) { /* audio is optional */ }
}
